import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SpaltenFeld } from '../schir-utils';
import { isNil } from 'lodash-es';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseEditorComponent } from '../dialog.service';

@Component({
	selector: 'schir-int-client-notiz-dialog',
	templateUrl: './notiz-dialog.component.html',
	styleUrls: ['./notiz-dialog.component.scss'],
	standalone: false,
})
export class NotizDialogComponent extends BaseEditorComponent {
	readonly notizFeld: SpaltenFeld = {
		label: 'Notizen',
		name: 'notiz',
		type: 'text',
	};

	readonly title: string;

	@Output() notizEvent: EventEmitter<string> = new EventEmitter();

	form: UntypedFormGroup = new UntypedFormGroup({
		notiz: new UntypedFormControl(null),
	});

	constructor(@Inject(MAT_DIALOG_DATA) data: NotizDialogData) {
		super();

		this.title = data.title;

		if (!isNil(data)) {
			this.form.patchValue(data);
		}
		if (data.readonly) {
			this.form.disable();
		}
	}

	async submit(): Promise<boolean> {
		this.notizEvent.emit(this.form.value.notiz);

		return true;
	}
}

export interface NotizDialogData {
	title: string;
	notiz: string;
	readonly?: boolean;
}
